export default {
  // Public events listing (eventos)
  "events.pageTitle": "Events — BajApp Xperiences",
  "events.listingTitle": "Events in Baja California Sur",
  "events.listingSubtitle": "Festivals, tournaments and celebrations in the area.",
  "events.emptyListing": "No upcoming events right now. Check back soon.",

  // Public single-event detail (evento)
  "events.detailTitleSuffix": "{{title}} — BajApp Xperiences",
  "events.notFound": "We couldn't find this event.",
  "events.viewAll": "View all events",
  "events.backToEvents": "Events",
  "events.bookRelated": "Book related experience",
  "events.moreInfo": "More information",

  // Home upcoming events section
  "events.upcomingTitle": "Upcoming events",
  "events.upcomingSubtitle": "What's happening in Baja California Sur",
  "events.seeAll": "See all",
  "events.viewEvent": "View event",

  // Admin events management
  "events.adminTitle": "Events",
  "events.newEvent": "New event",
  "events.loadError": "We couldn't load the events.",
  "events.adminEmpty": "No events yet. Create the first one.",
  "events.colEvent": "Event",
  "events.colDate": "Date",
  "events.colCity": "City",
  "events.colFeatured": "Featured",
  "events.colStatus": "Status",
  "events.statusPublished": "Published",
  "events.statusDraft": "Draft",
  "events.edit": "Edit",
  "events.delete": "Delete",
  "events.editEvent": "Edit event",
  "events.fieldTitle": "Title",
  "events.fieldShortDescription": "Short description (for cards)",
  "events.fieldDescription": "Full description",
  "events.fieldImageUrl": "Image URL",
  "events.uploadImage": "Upload image",
  "events.uploading": "Uploading…",
  "events.uploadError": "We couldn't upload the image.",
  "events.placeholderImageUrl": "https://… or /brand/…",
  "events.fieldStart": "Start",
  "events.fieldEnd": "End (opt.)",
  "events.fieldTime": "Time (opt.)",
  "events.fieldLocation": "Place",
  "events.fieldCity": "City",
  "events.fieldExternalUrl": "External link (opt.)",
  "events.placeholderExternalUrl": "https://…",
  "events.fieldTourSlug": "Tour slug (opt.)",
  "events.placeholderTourSlug": "for Book button",
  "events.fieldOrder": "Order",
  "events.fieldFeatured": "Featured (banner)",
  "events.fieldPublished": "Published",
  "events.cancel": "Cancel",
  "events.save": "Save",
  "events.errorTitleRequired": "Title is required.",
  "events.errorStartRequired": "Start date is required.",
  "events.errorSave": "An error occurred while saving.",
  "events.confirmDelete": "Delete the event \"{{title}}\"?",
};
